'use strict';

define('vb/private/vx/fullDigestExtensionRegistry',[
  'vb/private/vx/extensionRegistry',
  'vb/private/constants',
], (ExtensionRegistry, Constants) => {
  class FullDigestExtensionRegistry extends ExtensionRegistry {
    constructor(registryConfig) {
      super(registryConfig);
      this._digestState = Constants.DigestState.FULL;
      this._fetchManifestPromise = Promise.resolve(registryConfig.fetchFullManifestArray);
    }

    async _getLoadManifestPromise() {
      // eslint-disable-next-line prefer-const
      let [runtimeDigestPromise, requirejsInfoDigestPromise, , fullAppUiInfoDigestPromise] = await this._loadManifest();

      const appUiInfoDigestPromise = this._getFullAppUiInfoMap(fullAppUiInfoDigestPromise);
      requirejsInfoDigestPromise = requirejsInfoDigestPromise
        .then((requirejsInfo) => this._processRequirejsInfoDigest(requirejsInfo));

      return [runtimeDigestPromise, requirejsInfoDigestPromise, appUiInfoDigestPromise];
    }
  }

  return FullDigestExtensionRegistry;
});

